module.exports = __webpack_public_path__ + "img/frame (179).140ec4dc.jpg";